export class Rechnungstext {
    // BT-23
    betreff = ""
    // BT-24
    bemerkung = ""

    get notEmpty(): boolean {
        return this.betreff.trim().length > 0 || this.bemerkung.trim().length > 0
    }

    toJSON() {
        return {
            betreff: this.betreff,
            bemerkung: this.bemerkung,
        }
    }
}
